import { useState } from 'react';
import { Link } from 'react-router-dom';

import { getAnalyticsConsent, setAnalyticsConsent, trackAnalyticsPageView } from '../utils/analytics';

export default function ConsentBanner() {
  const [consent, setConsent] = useState(() => getAnalyticsConsent());

  if (consent) {
    return null;
  }

  async function handleAccept() {
    setAnalyticsConsent('accepted');
    setConsent('accepted');
    await trackAnalyticsPageView(window.location.pathname, window.location.search);
  }

  function handleDecline() {
    setAnalyticsConsent('declined');
    setConsent('declined');
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.copy}>
          <strong style={styles.title}>Cookies & Analytics</strong>
          <p style={styles.text}>
            Durch Klicken auf „Akzeptieren“ stimmen Sie der Speicherung von Cookies auf Ihrem Gerät
            zu, um die Navigation auf der Website zu verbessern, die Nutzung der Website zu
            analysieren und unsere Marketingmaßnahmen zu unterstützen. Weitere Informationen finden
            Sie in unserer{' '}
            <Link style={styles.link} to="/datenschutzhinweis">
              Datenschutzrichtlinie
            </Link>
            .
          </p>
        </div>

        <div style={styles.actions}>
          <button
            style={styles.secondaryButton}
            type="button"
            onClick={handleDecline}>
            Ablehnen
          </button>
          <button
            style={styles.primaryButton}
            type="button"
            onClick={() => void handleAccept()}>
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    position: 'fixed',
    left: 12,
    right: 12,
    bottom: 12,
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  card: {
    width: '100%',
    maxWidth: 1380,
    borderRadius: 18,
    background: '#f3f7fd',
    color: '#1f2937',
    border: '1px solid #cfd8e3',
    boxShadow: '0 14px 34px rgba(31, 41, 55, 0.12)',
    padding: '14px 14px 12px',
    display: 'flex',
    gap: 14,
    alignItems: 'stretch',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    pointerEvents: 'auto',
  },
  copy: {
    flex: '999 1 420px',
    minWidth: 0,
  },
  title: {
    display: 'block',
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 6,
    color: '#1f2937',
  },
  text: {
    margin: 0,
    fontSize: 13,
    lineHeight: 1.5,
    color: '#4b5563',
    maxWidth: 860,
  },
  link: {
    color: '#1f2937',
    fontWeight: 700,
    textDecoration: 'underline',
  },
  actions: {
    display: 'flex',
    gap: 12,
    flex: '1 1 240px',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    justifyContent: 'flex-end',
  },
  primaryButton: {
    border: 'none',
    borderRadius: 999,
    background: '#1f2937',
    color: '#ffffff',
    padding: '12px 16px',
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    flex: '1 1 140px',
  },
  secondaryButton: {
    borderRadius: 999,
    border: '1px solid transparent',
    background: 'transparent',
    color: '#1f2937',
    padding: '12px 16px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    flex: '1 1 140px',
  },
};
